//  Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { goBack } from 'react-router-redux'
import { warning } from 'react-notification-system-redux'
import { initialize } from 'redux-form'
import { loadingToggler } from 'redux/modules/loading'
import { AnalysisStatusIdEnum } from 'config/enums'
import { UNCAUGHT_ERROR } from 'errors'

import {
  assembleQuery,
  fetchEarthStationCasesCounts,
} from 'helpers/api'

import {
  AFS_GRID_FILTER,
  EARTH_STATION_RESULTS_FORM,
} from 'redux/modules/interferenceAnalysis/constants'

const initializeEarthStationResultsForm = () => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const {
        form,
        projectSummary,
      } = getState()

      const projectId = projectSummary.get('projectId')

      try {
        const { bandId } = form[AFS_GRID_FILTER].values

        const query = assembleQuery([{
          field: 'bandId',
          value: bandId,
        }])

        const { entity } = await fetchEarthStationCasesCounts(projectId, query)

        const initialValues = {
          // default these values just in case entity.analysisStatus is null for some reason
          analysisStatusId: null,
          analysisStatus: 'N/A',
          ...entity.analysisStatus,

          // this is the textarea for the user to define which case numbers they want to specify in their report.
          caseNumbers: '',
          selectAll: false,
        }

        // if the analysisStatusId isn't Completed, then we don't actually have any
        // Earth Station Cases to speak of. so we'll display this value as 'N/A' to the user.
        // but set it to null here
        // TODO NEXT - determine if we even need to set it or if null comes from API.
        initialValues.totalCaseNumbersCount = (
          initialValues.analysisStatusId === AnalysisStatusIdEnum.COMPLETED
            ? entity.totalCaseNumbersCount
            : null
        )

        await dispatch(initialize(
          EARTH_STATION_RESULTS_FORM,
          initialValues,
        ))

        // we want to know if we should disable the form completely
        // based on the data we got from the API.
        return (
          initialValues.analysisStatusId !== AnalysisStatusIdEnum.COMPLETED ||
          initialValues.totalCaseNumbersCount === 0
        )
      } catch (err) {
        console.warn(err)

        // if this failed to initialize, then tell them what happened
        dispatch(warning({
          message: err.message || UNCAUGHT_ERROR,
          title: 'Warning: Failed to initialize the Earth Station Results Page',
        }))
        // and get them outta here
        dispatch(goBack())
      }
    }
  ),
  )
)

export default initializeEarthStationResultsForm
